/**
 * Extracted from snippets/fa-main-product-upgrades-container.liquid (inline <script> at line 1).
 * Config bridge: window.__nsUpgradesContainerSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsUpgradesContainerSections = window.__nsUpgradesContainerSections || {};
  function boot(nsSectionId, nsSettings) {
  function upgradesContainerSlider() {
      let section = document.querySelector(`#shopify-section-${nsSectionId}`)
      let breakpoint = window.matchMedia('(min-width:700px)');
      let contentContainerEl = section.querySelector('.upgrade-container-parent')
      let swiperWrapperEl = section.querySelector('[data-swiper-wrapper-upgrades]')
      let swiperEl = section.querySelector('[data-swiper-container-upgrades]')
      let swiperPaginationEl = section.querySelector('.swiper-pagination-upgrades')
      // Get the total number of slides
      const totalSlides = swiperEl?.querySelectorAll('.swiper-slide').length;
      // Check if there is only one slide
      const isSingleSlide = totalSlides === 1;
      let layoutMobile;
      let layoutDesktop;
      if (contentContainerEl) {
        ({ layoutMobile, layoutDesktop } = contentContainerEl.dataset);
      }

        let upgradesContainerSwiper
      
        function waitForSwiper(callback) {
          if (typeof Swiper !== 'undefined') {
            callback();
          } else {
            const checkInterval = setInterval(() => {
              if (typeof Swiper !== 'undefined') {
                clearInterval(checkInterval);
                callback();
              }
            }, 100);
          }
        }

        function initializeSwiper () {
          if (upgradesContainerSwiper) return;
         upgradesContainerSwiper = new Swiper(swiperEl, {
          slidesPerView: isSingleSlide ? 1 : 1.1, // Set to 1 for a single slide
          spaceBetween: isSingleSlide ? 0 : 8,    // No space for a single slide
          speed: 600,
          breakpoints: isSingleSlide
            ? {} // No breakpoints needed for a single slide
            : {
                380: {
                  slidesPerView: 1.1,
                  spaceBetween: 8
                },
                480: {
                  slidesPerView: 1.1,
                  spaceBetween: 8
                },
                640: {
                  slidesPerView: 1.2,
                  spaceBetween: 8
                },
                800: {
                  slidesPerView: 1.2,
                  spaceBetween: 8
                },
                1024: {
                  slidesPerView: 1.2,
                  spaceBetween: 8
                }
              },
              autoHeight: true,
              pagination: {
                el: section.querySelector('.swiper-pagination-upgrades'),
                clickable: true
              },
              on: {
                init: function () {
                  this.pagination.render();
                  this.pagination.init();
                  this.pagination.update();
                }
              }
        });
        document.querySelectorAll(".upgrade-container-info-toggle-check").forEach((el) => {
        el.addEventListener("input", () => {
            if (el.checked) {
              upgradesContainerSwiper.slideNext()
            }
          })
        })
      }
      function breakpointChecker(breakpoint) {
          if (breakpoint.matches === true) {
            if (layoutDesktop == 'slider') {
              swiperWrapperEl.style.display = 'flex'
              swiperWrapperEl.classList.add('swiper-wrapper')
              swiperPaginationEl.style.display = 'block'
              waitForSwiper(() => {
                initializeSwiper()
              })
              return
            }
          } else if (breakpoint.matches === false) {
            if (layoutMobile == 'slider') {
              swiperWrapperEl.style.display = 'flex'
              swiperWrapperEl.classList.add('swiper-wrapper')
              swiperPaginationEl.style.display = 'block'
              waitForSwiper(() => {
                initializeSwiper()
              })
              return
            }
          }
      };
      if (contentContainerEl) {
        breakpointChecker(breakpoint);
      }
      breakpoint.addEventListener("change", () => {
          breakpointChecker(breakpoint)
      })
    }
    upgradesContainerSlider()
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        upgradesContainerSlider()
      });
    }
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
